export default {
    listagem: {
        titulo_pagina: 'Lista de Formatos de Arquivos',
        novo: 'Adicionar novo Formato de Arquivo',
        table: {
            empty: 'Nenhum Formato encontrado',
            nome: 'Nome',
            classe: 'Classe',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo Formato',
            editar: 'Editar Formato'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do Formato'
            },
            classe: {
                label: 'Classe',
                description: 'Classe que executa o Formato'
            },
            extensao: {
                label: 'Extensão',
                description: 'Extensão do arquivo gerado pelo Parser'
            },
            has_cloud_function: {
                label: 'Cloud Function',
                description: 'Formato de Arquivo possui Cloud Function de Conversão'
            },
            cloud_function: {
                label: 'Nome Cloud Function',
                description: 'Cloud Function que executa a Conversão',
                selecionar: 'Selecionar...'
            },
            status: {
                label: 'Status',
                description: 'Status ativo ou inativo do Formato'
            },
            botao_salvar : 'Salvar Formato'
        },
        create: {
            success: 'Formato criado com Sucesso!',
            error: 'Error ao criar Formato!'
        },
        update: {
            success: 'Formato editado com Sucesso!',
            error: 'Error ao editar Formato!'
        }
    }
}
